import { motion } from "framer-motion";
import { useLang } from "../i18n";

const IMAGES = {
  water:
    "https://images.unsplash.com/photo-1553775927-a071d5a6a39a?q=80&w=1600&auto=format&fit=crop",
  school:
    "https://images.pexels.com/photos/12448839/pexels-photo-12448839.jpeg?auto=compress&cs=tinysrgb&w=1600",
  agri: "https://images.unsplash.com/photo-1741874299706-2b8e16839aaa?q=80&w=1600&auto=format&fit=crop",
  kids: "https://images.unsplash.com/photo-1577819175009-4bec3ab382e9?q=80&w=2000&h=700&auto=format&fit=crop",
};

const SPANS = {
  water: "md:col-span-2 md:row-span-2 min-h-[320px] md:min-h-[520px]",
  school: "md:col-span-1 min-h-[250px]",
  agri: "md:col-span-1 min-h-[250px]",
  kids: "md:col-span-3 min-h-[280px]",
};

const EASE = [0.16, 1, 0.3, 1];

export default function Attivita() {
  const { t } = useLang();

  return (
    <section id="attivita" data-testid="attivita-section" className="py-28 md:py-36">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, ease: EASE }}
          className="text-[12px] font-semibold uppercase tracking-[0.35em] text-primary"
        >
          {t.activities.label}
        </motion.p>
        <div className="mt-5 flex flex-wrap items-end justify-between gap-6">
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.8, delay: 0.1, ease: EASE }}
            className="max-w-xl font-serif text-4xl leading-[1.05] tracking-tight text-white md:text-5xl"
          >
            {t.activities.title}
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.8, delay: 0.2, ease: EASE }}
            className="max-w-sm text-base text-white/60"
          >
            {t.activities.sub}
          </motion.p>
        </div>

        <div className="mt-16 grid grid-cols-1 gap-6 md:grid-cols-3">
          {t.activities.projects.map((p, i) => (
            <motion.article
              key={p.key}
              data-testid={`project-card-${p.key}`}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.85, delay: i * 0.1, ease: EASE }}
              className={`group relative overflow-hidden rounded-3xl border border-white/10 ${SPANS[p.key]}`}
            >
              <img
                src={IMAGES[p.key]}
                alt={p.title}
                className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-[#04132e]/35 transition-colors duration-500 group-hover:bg-[#04132e]/20" />
              <div className="absolute inset-x-0 bottom-0 h-2/3 bg-gradient-to-t from-[#030f26] via-[#030f26]/60 to-transparent" />
              <div className="relative flex h-full flex-col justify-end p-8">
                <span className="mb-4 w-fit rounded-full border border-white/25 bg-white/10 px-4 py-1 text-[11px] font-semibold uppercase tracking-[0.2em] text-white backdrop-blur-sm">
                  {p.tag}
                </span>
                <h3 className="font-serif text-3xl tracking-tight text-white md:text-4xl">
                  {p.title}
                </h3>
                <p className="mt-3 max-w-md text-sm leading-relaxed text-white/75 md:text-base">
                  {p.text}
                </p>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
